import React, { useEffect } from 'react'
import ResetPw from '../../components/auth/resetPw'
import { useDispatch } from 'react-redux'
import * as resetPwActions from '../../modules/auth/resetPw'
// resetPwState: 비밀번호 찾기 인증 통과 후 라우트 state로 전달되는 { simpleId, certToken }
const ResetPwContainer = ({ resetPwState }) => {

  const updateUserId = resetPwState ? resetPwState.simpleId : undefined
  const certToken = resetPwState ? resetPwState.certToken : undefined

  useEffect(() => {
    handleBlockPage()
  }, [])

  const dispatch = useDispatch()

  const handleBlockPage = () => { (updateUserId === undefined || certToken === undefined) && dispatch(resetPwActions.blockResetPw()) }
  const onResetPwRequest = (newPass) => { dispatch(resetPwActions.resetPwRequest(newPass)) }

  return (
    <ResetPw updateUserId={updateUserId} certToken={certToken} onResetPwRequest={onResetPwRequest} />
  )
}

export default ResetPwContainer
